import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const WATCHLIST_KEY = "moviepulse_watchlist";
let serverMode = false;

export const getWatchlist = () => {
  try {
    return JSON.parse(localStorage.getItem(WATCHLIST_KEY)) || [];
  } catch {
    return [];
  }
};

export const isInWatchlist = (id) => getWatchlist().some((m) => m.id === id);

const summarize = (movie) => ({ id: movie.id, title: movie.title, year: movie.year, country: movie.country, genres: movie.genres, palette: movie.palette, image: movie.image, rating: movie.rating, language: movie.language });

export const toggleWatchlist = (movie) => {
  const list = getWatchlist();
  const exists = list.some((m) => m.id === movie.id);
  const next = exists ? list.filter((m) => m.id !== movie.id) : [...list, summarize(movie)];
  localStorage.setItem(WATCHLIST_KEY, JSON.stringify(next));
  window.dispatchEvent(new Event("watchlist-changed"));
  if (serverMode) {
    (exists ? api.delete(`/me/watchlist/${movie.id}`) : api.post(`/me/watchlist/${movie.id}`)).catch(() => {});
  }
  return !exists;
};

export const syncWatchlistWithServer = async () => {
  try {
    const localIds = getWatchlist().map((m) => m.id);
    const r = await api.post("/me/watchlist/sync", { movie_ids: localIds });
    localStorage.setItem(WATCHLIST_KEY, JSON.stringify(r.data));
    serverMode = true;
    window.dispatchEvent(new Event("watchlist-changed"));
  } catch {
    serverMode = false;
  }
};

export const disableWatchlistSync = () => {
  serverMode = false;
};
